<template>
    <div>
        <el-dialog 
            title="审批"
            :visible.sync="auditDialog"
            width="60%"
            :before-close="closeAuditDialog"
            append-to-body
            :modal-append-to-body="false"
        >
            <avue-form 
                :option="auditFormOption"
                v-model="auditForm"
                @submit="auditFormSubmit"
                @error="auditFormError">
                <template slot="remark">
                        <div>
                            <el-input
                                type="textarea"
                                :rows="3"
                                maxlength="500"
                                show-word-limit
                                placeholder="请输入内容"
                                v-model="auditForm.remark">
                            </el-input>
                            <remarkModel :remark.sync="auditForm.remark" ref="auditFormRemarkModel"></remarkModel>
                        </div>
                   
                    </template>
                <template slot="attachList"> 
                    <vupload :fileList.sync = auditForm.attachList :disabled="false" :showButton="true"></vupload>
                </template>
                <template slot="menuForm">
                    <el-button @click="auditDialog=false" ><span class="el-icon-circle-clos"></span>取消</el-button>
                </template>
                </avue-form>
            
        </el-dialog>
    </div>
</template>
<script>
export default {
    data(){
        return{
            auditDialog:false,
            auditFormOption:{
                labelPosition: 'right',
                labelSuffix: '：',
                labelWidth: 120,
                gutter: 0,
                menuBtn: true,
                submitBtn: true,
                submitText: '提交',
                emptyBtn: false,
                emptyText: '清空',
                menuPosition: 'center',
                detail: false,
                tabs: false,
                column: [
                    {
                    type: 'radio',
                    label: '附件',
                    span: 24,
                    dicData:[
                        {
                            label:'审批通过',
                            value:1,
                        },
                        {
                            label:'审批不通过',
                            value:2,
                        },
                    ],
                    display: true,
                    formslot:true,
                    prop: 'attachList',
                    
                    
                },
                
                {
                    type: 'textarea',
                    label: '审核内容',
                    span: 24,
                    display: true,
                    formslot:true,
                    prop: 'remark',
                    rules:[{required:true,message:'请输入备注'},{ min: 0, max: 500, message: '请控制在500个字符内！', trigger: 'change' }]
                },
                
                ],
            }
        }
    },
    methods:{
         // 开始弹窗
        openAuditDialog(index,id){
            getRemarkList({orderId:this.orderId,actionType:index}).then(res=>{
                this.$refs.auditFormRemarkModel.setRemarkList(res.data);
            })
            this.auditDialog = true;
          
        },
        // 开始提交
        auditFormSubmit(form,done){
            form.orderId = this.orderId;
            start(form).then(res=>{
                if(res.msg=='操作成功'){
                    this.$message({
                        message: res.msg,
                        type: 'success'
                    });
                    this.robOrderDialog = false;
                     this.dialogVisible = false;
                }else{
                    this.$message.error(res.msg);
                }
               
                this.robOrderDialog = false;
                done()
            }).catch(err=>{
                
                
                done()
            })
        },
        // 开始提交报错
        auditFormError(done){
            done()
        },
        // 关闭开始弹窗
        closeAuditDialog(done){
            this.auditForm = {
                
            }
            done()
        },
    }
}
</script>